export const TASK_TYPES = {
  INSTANCE: "INSTANCE",
  SERIES: "SERIES"
};

export default TASK_TYPES;
